<template>
  <ModalComponent
    name="translation-warning-dialog"
    classes="rounded-full"
    width="600"
    height="auto"
    :adaptive="true"
    :click-to-close="false"
  >
    <div
      class="fixed inset-0 z-[999] overflow-y-auto"
      aria-labelledby="AI Translation Notice"
      role="dialog"
      aria-modal="true"
    >
      <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div
          class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          aria-hidden="true"
        />
        <!-- This element is to trick the browser into centering the dialog contents. -->
        <span
          class="hidden sm:inline-block sm:h-screen sm:align-middle"
          aria-hidden="true"
        >&#8203;</span>
        <div
          class="inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:w-full sm:max-w-lg sm:p-6 sm:align-middle"
        >
          <div class="mt-3 text-center sm:mt-5">
            <div class="flex items-start gap-2">
              <span class="text-yellow-600">
                <svg
                  class="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clip-rule="evenodd"
                  />
                </svg>
              </span>
              <div class="flex flex-col gap-2">
                <h3 class="text-lg text-left font-medium leading-6 text-gray-900">
                  AI Translation Notice
                </h3>
                <p class="text-sm text-left text-gray-500">
                  We use an AI-assisted translation management system to provide relevant translations throughout our platform quickly. If you notice an error in translations, please refresh the page. If the errors persist,
                  <a
                    href="https://zunocarbon.atlassian.net/servicedesk/customer/portal/3/create/38"
                    class="text-blue-600 underline"
                  >let us know here</a>.
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6 flex gap-2 items-center justify-between">
            <div class="flex items-center">
              <input
                id="dont-show-again"
                v-model="dontShowAgain"
                type="checkbox"
                class="h-4 w-4 text-zuno-primary-2 focus:ring-zuno-primary-2 border-gray-300 rounded"
              >
              <label
                for="dont-show-again"
                class="ml-2 block text-sm text-gray-700 cursor-pointer"
              >
                Don't show this again
              </label>
            </div>
            <BaseButton
              @click="onClose"
            >
              Okay
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  </ModalComponent>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  dismiss: []
  close: []
}>()

const dontShowAgain = ref(false)

const onClose = (): void => {
  const { $modal } = useNuxtApp()

  dontShowAgain.value ? emit('dismiss') : emit('close')

  $modal.hide('translation-warning-dialog')
}
</script>
